module.exports = __webpack_public_path__ + "img/crc-06.7c65bbef.jpg";